import { isRouteErrorResponse, useRouteError, Link } from 'react-router';
import NotFoundPage from './NotFoundPage.jsx';

/**
 * Route-level error boundary. A 404 from the router renders the real 404 page;
 * anything else renders a plain apology. The underlying message is only shown in
 * development — in production it could leak internals.
 */
export default function RouteErrorPage() {
  const error = useRouteError();

  if (isRouteErrorResponse(error) && error.status === 404) {
    return <NotFoundPage />;
  }

  return (
    <section className="page-gutter mx-auto max-w-(--container-page) py-24 md:py-36">
      <p className="label text-stamp-ink">Something went wrong</p>
      <h1 className="text-display-lg mt-6 max-w-[22ch]">We have dropped this one.</h1>
      <p className="text-read font-display text-ink-80 mt-6 max-w-(--container-prose)">
        The page could not be loaded. Try again, and if it keeps happening let us know what you were
        doing.
      </p>

      {import.meta.env.DEV && (
        <pre className="bg-paper-raised border-rule text-ink-80 mt-8 overflow-x-auto border p-4 text-xs">
          {isRouteErrorResponse(error)
            ? `${error.status} ${error.statusText}`
            : (error?.stack ?? String(error))}
        </pre>
      )}

      <Link
        to="/"
        className="label bg-ink text-paper hover:bg-stamp-ink mt-10 inline-block px-6 py-3.5 no-underline transition-colors duration-200"
      >
        Back to the shop
      </Link>
    </section>
  );
}
